export default __webpack_public_path__ + "static/media/family_5.ed98307b.webp";